export const checkErrorYear = (yearItem) => {
  const currentYear = new Date().getFullYear();
  const year = parseInt(yearItem, 10);
  if (year.toString()?.length !== 4 || year > currentYear) {
    return true;
  } else {
    return false;
  }
}; // validate year for filter or add Report
